module.exports = __webpack_public_path__ + "static/Karen-Hincapie-00148eba96d818eea49598e6be304e5c.png";